const maskPhone = (phone: string | number | null | undefined): string => {
  // Verificar se o valor existe e converter para string
  if (!phone && phone !== 0) return ''
  
  // Converter para string se for número
  let phoneStr = String(phone).trim()

  // Remove todos os caracteres não numéricos
  phoneStr = phoneStr.replace(/\D/g, '')

  // Se não tem dígitos suficientes, retorna sem formatação
  if (phoneStr.length < 8) {
    return phoneStr
  }

  let result = phoneStr
  
  // Aplica a máscara para telefones com 13 dígitos (código país + DDD + número)
  // Ex: 5511956606248 -> (11)95660-6248
  if (phoneStr.length === 13 && phoneStr.startsWith('55')) {
    // Remove o código do país (55) e aplica máscara no restante
    const withoutCountryCode = phoneStr.substring(2)
    return withoutCountryCode.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1)$2-$3')
  }
  // Aplica a máscara para telefones com 12 dígitos (código país + DDD + número fixo)
  // Ex: 551133334444 -> (11)3333-4444
  else if (phoneStr.length === 12 && phoneStr.startsWith('55')) {
    // Remove o código do país (55) e aplica máscara no restante
    const withoutCountryCode = phoneStr.substring(2)
    return withoutCountryCode.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1)$2-$3')
  }
  // Aplica a máscara (99)99999-9999 para telefones com 11 dígitos (celular com DDD)
  else if (phoneStr.length === 11) {
    return phoneStr.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1)$2-$3')
  }
  // Para telefones com 10 dígitos (99)9999-9999 (fixo com DDD)
  else if (phoneStr.length === 10) {
    return phoneStr.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1)$2-$3')
  }
  // Para telefones com 9 dígitos 99999-9999 (celular sem DDD)
  else if (phoneStr.length === 9) {
    return phoneStr.replace(/^(\d{5})(\d{4})$/, '$1-$2')
  }
  // Para telefones com 8 dígitos 9999-9999 (fixo sem DDD)
  else if (phoneStr.length === 8) {
    return phoneStr.replace(/^(\d{4})(\d{4})$/, '$1-$2')
  }

  // Se não se encaixa em nenhum padrão, retorna apenas os números
  return phoneStr
}

export { maskPhone }
